import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Team List row placeholder (My Account &gt; Teams tab) — mirrors
 * `AccountTeams.web.tsx`'s row: avatar + name, role, member count, plan-tag
 * pill, and upgrade-CTA text, at the same `columnFlexes`/height as the real
 * `TeamRowContainer` row and `sectionHeader()`.
 */
export const TeamListRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'team-list-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      height={48}
      paddingHorizontal='xs'>
      <Box flex={0.7} flexDirection='row' alignItems='center'>
        <Skeleton
          variant='rect'
          width={24}
          height={24}
          borderRadius='xxs'
          style={{ marginRight: theme.spacing.m }}
        />
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flex={0.4}>
        <Skeleton variant='text' width='70%' />
      </Box>
      <Box flex={0.2}>
        <Skeleton variant='text' width='40%' />
      </Box>
      <Box flex={1}>
        <Skeleton variant='rect' width={100} height={20} borderRadius='xxs' />
      </Box>
      <Box flex={1}>
        <Skeleton variant='text' width='50%' />
      </Box>
    </Box>
  );
};
